import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import CloseIcon from '@mui/icons-material/Close'
import DnsIcon from '@mui/icons-material/Dns'
import WidgetsIcon from '@mui/icons-material/Widgets'
import AddIcon from '@mui/icons-material/Add'
import { get } from 'lodash'

function TerminalSessionList({ sessions = [], currentSessionId, onSelect, onClose }) {
  if (!sessions || sessions.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          <FormattedMessage id="terminal.sessions.empty" />
        </Typography>
      </Box>
    )
  }

  const getSessionName = (session) => {
    if (session.serviceName) {
      return session.serviceName
    }
    return session.nodeName || 'Unknown'
  }

  const getSessionIcon = (session) => {
    if (session.pending) {
      return <AddIcon fontSize="small" sx={{ mr: 1 }} />
    }
    if (session.dockerServiceId) {
      return <WidgetsIcon fontSize="small" sx={{ mr: 1 }} />
    }
    return <DnsIcon fontSize="small" sx={{ mr: 1 }} />
  }

  const handleClose = (event, sessionId) => {
    event.stopPropagation()
    if (onClose) {
      onClose(sessionId)
    }
  }

  return (
    <Box sx={{ height: '100%', overflow: 'auto' }}>
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography variant="subtitle2" color="text.secondary">
          <FormattedMessage id="terminal.sessions.title" />
        </Typography>
      </Box>
      <List disablePadding>
        {sessions.filter(Boolean).map((session) => (
          <ListItem
            key={session.id}
            disablePadding
            sx={{
              borderLeft: currentSessionId === session.id ? 3 : 0,
              borderLeftColor: 'primary.main',
            }}
          >
            <ListItemButton
              selected={currentSessionId === session.id}
              onClick={() => onSelect(session.id)}
              sx={{ pr: 6 }}
            >
              <ListItemText
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {getSessionIcon(session)}
                    <Typography variant="body2" noWrap>
                      {getSessionName(session)}
                    </Typography>
                  </Box>
                }
                secondary={
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {session.nodeName}
                  </Typography>
                }
              />
            </ListItemButton>
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={(e) => handleClose(e, session.id)}
                aria-label="close"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default TerminalSessionList
